import React from 'react';
import ComingSoon from 'components/ComingSoon';

export const Archived = () => (
  <ComingSoon text="Archive data that you no longer need but may need in the future. You can easily unarchive and manage your archive whenever you want." />
);
